import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import CertificateListing from "../../components/Certificate/CertificateListing";

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; 
  padding: 20px;
  min-height: 72vh;
  background-color: transparent;

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 16px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    padding: 12px;
  }
`;

const ResourcesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 800px;
  margin-top: 20px;

  @media (max-width: ${breakpoints.tablet}px) {
    min-width: unset;
    width: 100%;
    gap: 16px;
    margin-top: 16px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    gap: 12px;
    margin-top: 12px;
  }
`;

const CertificateWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: ${breakpoints.tablet}px) {
    padding: 0 10px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    padding: 0 8px;
  }
`;

const CertificatePage = ({ colors }) => {
  const user = useSelector((state) => state.auth.user);
  const userName = user.first_name;
  const navigate = useNavigate();
  const chapters = useSelector((state) => state.ilearn.chapters);
  const modules = useSelector((state) => state.ilearn.modules);

  return (
    <DashboardContainer>
      <ResourcesContainer>
        <CertificateWrapper>
          <CertificateListing colors={colors} />
        </CertificateWrapper>
      </ResourcesContainer>
    </DashboardContainer>
  );
};

export default CertificatePage;
